import { takeLatest, call, put } from 'redux-saga/effects';
import dataApi from '../../apis/dataApi';
import * as constants from './constants';
import * as actions from './actions';
import handleError from '../handleError';

export function* fetchDish(action) {
   console.log(action.actionType,"actionType")
  try {
    const formulaCode = action.payload;
    const actionType = action.actionType;
    const response = yield call(dataApi.fetchDish, formulaCode, actionType);
    yield put(actions.fetchDishDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchDishFail',
      put(actions.fetchDishFail(error))
    );
  }
}

export function* fetchDishes(action) {
  // console.log(action.payload,"saga")
  try {
    const response = yield call(dataApi.fetchDishes, action.payload);
    yield put(actions.fetchDishesDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchDishesFail',
      put(actions.fetchDishesFail(error))
    );
  }
}

export function* fetchExcludedDishes() {
  try {
    const response = yield call(dataApi.fetchExcludedDishes);
    yield put(actions.fetchExcludedDishesDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchExcludedDishesFail',
      put(actions.fetchExcludedDishesFail(error))
    );
  }
}

export function* excludeDishes(action) {
  try {
    const formulaCodes = action.payload;
    const response = yield call(dataApi.excludeDishes, formulaCodes);
    yield put(actions.excludeDishesDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.excludeDishesFail',
      put(actions.excludeDishesFail(error))
    );
  }
}

export function* includeDishes(action) {
  try {
    const formulaCodes = action.payload;
    const response = yield call(dataApi.includeDishes, formulaCodes);
    yield put(actions.includeDishesDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.includeDishesFail',
      put(actions.includeDishesFail(error))
    );
  }
}
export function* getProductAreaList(action) {
  try {
    const response = yield call(dataApi.fetchProductArea);
    yield put(actions.getProductAreaDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.productAreaFail',
      put(actions.getProductAreaFail(error))
    );
  }
}
// TODO Update i18n for fails

export default [
  takeLatest(constants.FETCH_DISH, fetchDish),
  takeLatest(constants.FETCH_DISHES, fetchDishes),
  takeLatest(constants.FETCH_EXCLUDED_DISHES, fetchExcludedDishes),
  takeLatest(constants.EXCLUDE_DISHES, excludeDishes),
  takeLatest(constants.INCLUDE_DISHES, includeDishes),
  takeLatest(constants.GET_PRODUCT_AREA,getProductAreaList)
];
